import React from "react"

export default function Info2() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
      <g clipPath="url(#clip0_1711_8085)">
        <path d="M9.27295 1.90381C5.13295 1.90381 1.77295 5.26381 1.77295 9.40381C1.77295 13.5438 5.13295 16.9038 9.27295 16.9038C13.4129 16.9038 16.7729 13.5438 16.7729 9.40381C16.7729 5.26381 13.4129 1.90381 9.27295 1.90381ZM9.27295 13.1538C8.86045 13.1538 8.52295 12.8163 8.52295 12.4038V9.40381C8.52295 8.99131 8.86045 8.65381 9.27295 8.65381C9.68545 8.65381 10.0229 8.99131 10.0229 9.40381V12.4038C10.0229 12.8163 9.68545 13.1538 9.27295 13.1538ZM10.0229 7.15381H8.52295V5.65381H10.0229V7.15381Z" fill="#5B5E71" />
      </g>
      <defs>
        <clipPath id="clip0_1711_8085">
          <rect width="18" height="18" fill="white" transform="translate(0.272949 0.403809)" />
        </clipPath>
      </defs>
    </svg>
  )
}
